export default "__VITE_ASSET__jzKU31iC__"